import handler from '../handler/handler';
import messages from '../handler/messages/service-messages';

const statusHandler = handler(messages);

export default {
  actions: {
    getServiceConfig: async ({ commit, getters }) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/services');
      return result;
    },

    createServiceConfig: async ({ commit, getters }, serviceConfig) => {
      const config = {
        pickupOrderLimit: serviceConfig.pickupOrderLimit,
        pickupOrderItemsLimit: serviceConfig.pickupOrderItemsLimit,
        soldOutLimit: serviceConfig.soldOutLimit,
        orderSoonLimit: serviceConfig.orderSoonLimit,

        wpNoshowLimitDays: serviceConfig.wpNoshowLimitDays,
        wpCutoffHourList: serviceConfig.wpCutoffHourList,

        e24NoshowLimitDays: serviceConfig.e24NoshowLimitDays,
        e24CancelCutoffHour: serviceConfig.e24CancelCutoffHour,
        e24OrderCutoffHour: serviceConfig.e24OrderCutoffHour,
        e24DeliveryDelayDays: serviceConfig.e24DeliveryDelayDays,

        androidMinVersion: serviceConfig.androidMinVersion,
        androidCurrentVersion: serviceConfig.androidCurrentVersion,
        iosMinVersion: serviceConfig.iosMinVersion,
        iosCurrentVersion: serviceConfig.iosCurrentVersion,
      };

      const result = await statusHandler.authPost({ commit, getters }, '/api/services', config);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/service.js